import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IDefaultConfig } from '../models/i-default-config';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DefaultConfigService {
  private readonly configBaseUrl = environment.baseUrls.api + 'default-config';

  constructor(private http: HttpClient) {}

  // Save single or multiple configs
  saveConfig(config: IDefaultConfig | IDefaultConfig[]): Observable<any> {
    const url = `${this.configBaseUrl}/save`;
    return this.http.post(url, config).pipe(
      map((res: any) => res),
      catchError(this.handleError('Save Config'))
    );
  }

  // Get all configs for current user
  getAllConfigs(): Observable<IDefaultConfig[]> {
    const url = `${this.configBaseUrl}/all`;
    return this.http.get<IDefaultConfig[]>(url).pipe(
      catchError(this.handleError('Get All Configs'))
    );
  }

  // Get configs by groupId (path param)
  getConfigsByGroup(groupId: number): Observable<IDefaultConfig[]> {
    const url = `${this.configBaseUrl}/group/${groupId}`;
    return this.http.get<IDefaultConfig[]>(url).pipe(
      catchError(this.handleError('Get Configs by Group'))
    );
  }

  // Get config by name (path param)
  getConfigByName(name: string): Observable<IDefaultConfig> {
    const url = `${this.configBaseUrl}/name/${name}`;
    return this.http.get<IDefaultConfig>(url).pipe(
      catchError(this.handleError('Get Config by Name'))
    );
  }

  // Get config using query parameters
  queryConfigs(params: { groupId?: number; name?: string }): Observable<IDefaultConfig[]> {
    const url = `${this.configBaseUrl}`;
    let httpParams = new HttpParams();

    if (params.groupId !== undefined) {
      httpParams = httpParams.set('groupId', params.groupId.toString());
    }
    if (params.name) {
      httpParams = httpParams.set('name', params.name);
    }

    return this.http.get<IDefaultConfig[]>(url, { params: httpParams }).pipe(
      catchError(this.handleError('Query Configs'))
    );
  }

  // Delete config by name, id or groupId
  deleteConfig(criteria: { name?: string; id?: string; groupId?: number }): Observable<any> {
    const url = `${this.configBaseUrl}/delete`;
    return this.http
      .request('delete', url, {
        body: criteria,
      })
      .pipe(
        map((res: any) => res),
        catchError(this.handleError('Delete Config'))
      );
  }

  private handleError(operation: string) {
    return (error: any): Observable<never> => {
      console.error(`[ERROR]: ${operation} failed`, error);
      return throwError(() => new Error(`${operation} failed: ${error.message}`));
    };
  }
}
